import { ICredencial, IPassword } from '../Models/Security';
import Service from './Service';

export default class ServiceSession extends Service {

	public login(cred: ICredencial) {
		return this.wrapper.post('auth', JSON.stringify(cred));
	}

	public me() {
		return this.wrapper.get('user/me');
	}

	public fetchFaenas(id: number) {
		return this.wrapper.get(`user/faena/${id}`)
	}

	public logout() {
		return this.wrapper.delete('auth/logout');
	}

	public changePassword(password: IPassword) {
		return this.wrapper.post('auth/password', JSON.stringify(password));
	}
}
